import {
  AfterContentInit,
  Component,
  ElementRef,
  EventEmitter,
  Input, OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChange,
  SimpleChanges
} from '@angular/core';
import {interval as observableInterval, Observable, Subscription} from 'rxjs';
import {map} from 'rxjs/operators';
import {CounterService} from '../../_services/counter.service';

@Component({
  selector: 'app-universalcounter',
  template: `

      <div *ngIf="!winaijaStyle" class="lottery-time">{{message}}</div>
      <div *ngIf="winaijaStyle" class="lottery-time-winaija" [innerHTML]="message"></div>
  `,
  styleUrls: ['./universalcounter.component.scss']
})
export class UniversalcounterComponent implements OnInit, OnDestroy, AfterContentInit, OnChanges {

  private future: Date;
  private futureString: string;
  private diff: number;
  private $counter: Observable<number>;
  private subscription: Subscription;
  public message: string;
  lotteryX: any;
  @Input() lottery;
  @Input() local;
  @Input() winaijaStyle;
  private _lottery: string;
  @Output() inputDate = new EventEmitter<any>();
  triggered: number;

  constructor(elm: ElementRef, public counterService: CounterService) {
  }

  dhms(t) {
    // t = 365;
    let days, hours, minutes, seconds;
    days = Math.floor(t / 86400);
    t -= days * 86400;
    hours = Math.floor(t / 3600) % 24;
    t -= hours * 3600;
    minutes = Math.floor(t / 60) % 60;
    t -= minutes * 60;
    seconds = t % 60;
    const language = localStorage.getItem('pageLanguage');
    if (this.local) {
      if (hours < 10) {
        hours = '0' + hours;
      }
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
      if (seconds < 10) {
        seconds = '0' + seconds;
      }
      return [
        hours + ' :',
        minutes + ' :',
        seconds,
      ].join(' ');
    } else {
      if (this.winaijaStyle) {
        return '<div class=\'clockWrapper\'><div class=\'element days\'><div class=\'number\'>' + days + '</div><div class=\'text\'>DAYS</div></div><div class=\'element hours\'><div class=\'number\'>' + hours + '</div><div class=\'text\'>HOURS</div></div><div class=\'element minutes\'><div class=\'number\'>' + minutes + '</div><div class=\'text\'>MINS</div></div><div class=\'element seconds\'><div class=\'number\'>' + seconds + '</div><div class=\'text\'>SEC</div></div></div>';
      } else {
        if (language === 'de') {
          return [
            days + 'T',
            hours + 'St',
            minutes + 'M',
            seconds + 'S'
          ].join(' ');
        } else {
          return [
            days + 'd',
            hours + 'h',
            minutes + 'm',
            seconds + 's',
          ].join(' ');
        }
      }

    }
  }

  ngOnInit() {
    this.triggered = 0;
    this.setCounter();
  }

  ngOnChanges(changes: SimpleChanges) {
    const lottery: SimpleChange = changes.lottery;
    this.lottery = lottery.currentValue;
    if (lottery.currentValue) {
      this.setCounter();
    }

  }

  ngAfterContentInit() {
  }

  setCounter() {
    if (this.lottery && this.counterService.lotteryTable && this.counterService.lotteryTable[0]) {
      this.lotteryX = this.counterService.lotteryTable[0][this.lottery];
      const timeNow = Math.round((new Date()).getTime() / 1000);
      const correctionTime = timeNow - this.counterService.downloadTime;
      this.lotteryX = this.lotteryX - correctionTime;
      this.startClock();
    } else {
      setTimeout(() => {
        this.setCounter();
      }, 500);
    }
  }

  startClock() {
    this.triggered++;
    if (this.triggered === 1) {
      this.$counter = observableInterval(1000).pipe(map((x) => {
        if (this.lotteryX > 0) {
          this.lotteryX--;
        } else {
          this.lotteryX = 0;
        }
        return x;
      }));
      this.subscription = this.$counter.subscribe((x) => this.message = this.dhms(this.lotteryX));
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  formatDate(obj) {
    if (obj) {
      return obj.toString().replace(/\s/g, 'T');
    } else {
      setTimeout(() => {
        this.formatDate(obj);
      }, 500);

    }

  }

}
